import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppContext } from 'services/context';
import { useScreenSize } from 'services/hooks';
import MissingPage from 'pages/MissingPage';
import { Rate } from 'pages/ReviewPage';
import Carousel from 'components/Carousel';

import './style.css';

const Testimonials = () => {
	const { Api } = useAppContext();
	const [testimonialData, seTestimonialData] = useState();
	const { mode } = useParams();
	const MODES = Object.freeze({
		CAROUSEL: 'carousel',
		LIST: 'list',
	});

	const screenSize = useScreenSize();
	const MOBILE_SIZE = process.env.REACT_APP_MOBILE_SIZE;
	const isMobile = screenSize.width <= MOBILE_SIZE;

	useEffect(() => {
		if (!mode) return;
		(async () => {
			const res = await Api.GetAllTestimonials(mode);
			if (res.testimonials) {
				seTestimonialData(res.testimonials);
			}
		})();
	}, []);

	if (!mode || ![MODES.CAROUSEL, MODES.LIST].includes(mode)) return <MissingPage />;

	return (
		<div className="Testimonials">
			{mode === MODES.CAROUSEL && (
				<div className="Testimonials__carousel">
					<Carousel
						itemsPerPage={isMobile ? 1 : 3}
						showArrows
						showDots
						items={testimonialData}
						renderItem={item => <TestimonialCard data={item} starSize={isMobile ? 25 : 30} />}
					/>
				</div>
			)}
			{mode === MODES.LIST && (
				<div className="Testimonials__list">
					{testimonialData &&
						testimonialData?.length > 0 &&
						testimonialData?.map(t => {
							return <TestimonialCard data={t} starSize={isMobile ? 25 : 30} />;
						})}
				</div>
			)}
		</div>
	);
};

const TestimonialCard = ({ data, starSize }) => {
	const { fname, lname, courseName, country, freeText, rating, date } = data;
	return (
		<div className="TestimonialCard" key={data.questionnaireId}>
			<div className="TestimonialCard__user_name">
				{fname} {lname}
			</div>
			{country && <div className="TestimonialCard__country">{country}</div>}
			<div className="TestimonialCard__course_name">{courseName}</div>
			<div className="TestimonialCard__content">{freeText}</div>

			<div className="TestimonialCard__rate">
				<Rate stars={5} value={rating} starSize={starSize} readOnly starColor="#F1C644" />
			</div>
			<div className="TestimonialCard__date">{new Date(date).toLocaleDateString()}</div>
		</div>
	);
};

export default Testimonials;
